import { apiSlice } from 'app/api/apiSlice'

export const passwordChangeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @param {payload} object -
     * {
     *  "oldPassword": "123456",
     *  "newPassword": "1234567",
     *  "email": "noelia.gonzalez@accelone.com",
     *  "number": 2903
     * }
     */
    passwordChange: builder.mutation({
      query: (payload) => ({
        url: '/bouser/auth/resetpassword',
        method: 'PUT',
        body: { ...payload },
      }),
    }),
  }),
  overrideExisting: true,
})

export const { usePasswordChangeMutation } = passwordChangeApiSlice
